import { useEffect, useRef } from 'react';
export const useOnUnmount = callback => {
  const cleanupRef = useRef(callback);
  cleanupRef.current = callback;
  useEffect(() => {
    return () => cleanupRef.current();
  }, []);
};
//# sourceMappingURL=use-on-unmount.js.map